import { createFileRoute } from "@tanstack/react-router";
import Meeting from "@/pages/Meeting";

export const Route = createFileRoute("/meeting")({
  component: Meeting,
});
